import React from "react";
import "../styles/card4.css";
import RouteChefAd from "./comp1test";
import RouteChefAd2 from "./comp2test";

export default function Card4() {
    return (
        <div class="routechef-section">
            <RouteChefAd />
            <RouteChefAd2 />
        </div>

    )
}